var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isPageLoading
    ? _c("div", [
        _vm.hasGlobalAccess && (_vm.user != null || _vm.currentuser != null)
          ? _c(
              "div",
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-title",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoggedInUserActive,
                            expression: "!isLoggedInUserActive"
                          }
                        ]
                      },
                      [
                        _c("label", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.$t("msguserisnotactive")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-card",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoggedInUserActive,
                        expression: "isLoggedInUserActive"
                      }
                    ]
                  },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.alllangauges,
                        label: _vm.$t("selectlanguage"),
                        "item-text": "language",
                        "item-value": "id",
                        dense: "",
                        filled: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.selectedLangChanged()
                        }
                      },
                      model: {
                        value: _vm.selectedlanguage,
                        callback: function($$v) {
                          _vm.selectedlanguage = $$v
                        },
                        expression: "selectedlanguage"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-data-table", {
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.languagesTable,
                        search: _vm.search,
                        "footer-props": {
                          itemsPerPageOptions: _vm.tableItemsPerPage,
                          itemsPerPageText: _vm.rowsperpage
                        },
                        options: _vm.options
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header.selectedLanguage",
                            fn: function(ref) {
                              var header = ref.header
                              return [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      (header.text = _vm.selectedlangText)
                                    ) +
                                    "\n                "
                                )
                              ]
                            }
                          },
                          {
                            key: "top",
                            fn: function() {
                              return [
                                _c(
                                  "v-toolbar",
                                  { attrs: { flat: "", dense: "" } },
                                  [
                                    _c("h3", [
                                      _vm._v(_vm._s(_vm.$t("languages")))
                                    ]),
                                    _vm._v(" "),
                                    _c("v-divider", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.isUpdateAllButtonActive,
                                          expression: "!isUpdateAllButtonActive"
                                        }
                                      ],
                                      staticClass: "mx-4",
                                      attrs: { inset: "", vertical: "" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "v-dialog",
                                      {
                                        attrs: { "max-width": "500px" },
                                        model: {
                                          value: _vm.dialog,
                                          callback: function($$v) {
                                            _vm.dialog = $$v
                                          },
                                          expression: "dialog"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.dialog &&
                                                  _vm.statusmessages.length > 0,
                                                expression:
                                                  "dialog && statusmessages.length > 0"
                                              }
                                            ],
                                            attrs: { id: "error" }
                                          },
                                          [
                                            _c(
                                              "v-alert",
                                              {
                                                attrs: {
                                                  value: true,
                                                  type: "error"
                                                }
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "ul",
                                                    _vm._l(
                                                      _vm.statusmessages,
                                                      function(status, index) {
                                                        return _c(
                                                          "li",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  status.message
                                                                ) +
                                                                "\n                                            "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-card",
                                          [
                                            _c(
                                              "v-card-title",
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "headline" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.formTitle)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.close(1)
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("close")]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-card-text",
                                              [
                                                _c(
                                                  "v-container",
                                                  [
                                                    _c(
                                                      "v-row",
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "12",
                                                              sm: "8",
                                                              md: "8"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-chip",
                                                              {
                                                                staticClass:
                                                                  "mb-2",
                                                                attrs: {
                                                                  large: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .editedItem
                                                                      .key
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "12",
                                                              sm: "8",
                                                              md: "8"
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label: _vm.$t(
                                                                  "english"
                                                                )
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.editedItem
                                                                    .english,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.editedItem,
                                                                    "english",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "editedItem.english"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        !_vm.isUpdateAllButtonActive
                                                          ? _c(
                                                              "v-col",
                                                              {
                                                                attrs: {
                                                                  cols: "12",
                                                                  sm: "8",
                                                                  md: "8"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        _vm.selectedlangText
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .editedItem
                                                                          .selectedLanguage,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.editedItem,
                                                                          "selectedLanguage",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "editedItem.selectedLanguage"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-card-actions",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      color: "blue darken-1",
                                                      text: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.close(1)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("cancel"))
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "mb-2",
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    },
                                                    on: { click: _vm.save }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("save"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-dialog",
                                      {
                                        attrs: { "max-width": "900px" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            color: "primary",
                                                            dark: "",
                                                            disabled:
                                                              _vm.isUpdateAllButtonActive
                                                          }
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("updateall")
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          172877736
                                        ),
                                        model: {
                                          value: _vm.dialog1,
                                          callback: function($$v) {
                                            _vm.dialog1 = $$v
                                          },
                                          expression: "dialog1"
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "v-card",
                                          [
                                            _c(
                                              "v-card-title",
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "headline" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.formTitle)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.close(1)
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("close")]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-card-text",
                                              [
                                                _c(
                                                  "v-container",
                                                  _vm._l(
                                                    _vm.languagesTable,
                                                    function(item) {
                                                      return _c(
                                                        "v-row",
                                                        { key: item.id },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                sm: "4",
                                                                md: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      item.key
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.english,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item,
                                                                        "english",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "item.english"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                sm: "4",
                                                                md: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      _vm.selectedlangText
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.selectedLanguage,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item,
                                                                        "selectedLanguage",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "item.selectedLanguage"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-card-actions",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      color: "blue darken-1",
                                                      text: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.close(1)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("cancel"))
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "mb-2",
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.SaveLanguageData
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("saveall"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider", {
                                      staticClass: "mx-4",
                                      attrs: { inset: "", vertical: "" }
                                    }),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      attrs: {
                                        "append-icon": "mdi-magnify",
                                        label: _vm.$t("searchall"),
                                        "single-line": "",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.search,
                                        callback: function($$v) {
                                          _vm.search = $$v
                                        },
                                        expression: "search"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "item.action",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { small: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.editItem(item)
                                      }
                                    }
                                  },
                                  [_vm._v("mdi-pencil")]
                                )
                              ]
                            }
                          },
                          {
                            key: "no-data",
                            fn: function() {
                              return [
                                _c(
                                  "v-alert",
                                  {
                                    attrs: {
                                      border: "right",
                                      "colored-border": "",
                                      type: "error",
                                      elevation: "2"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("norecordsfound")))]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mb-2",
                        attrs: {
                          color: "primary",
                          dark: "",
                          disabled: _vm.isSaveButtonActive
                        },
                        on: {
                          click: function($event) {
                            return _vm.SaveLanguageData()
                          }
                        }
                      },
                      [_vm._v("Save All")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm.user != null || _vm.currentuser != null
          ? _c(
              "div",
              [
                _c(
                  "v-alert",
                  {
                    attrs: {
                      outlined: "",
                      type: "warning",
                      prominent: "",
                      border: "left"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("accessdenied")))]
                )
              ],
              1
            )
          : _vm._e()
      ])
    : _c(
        "div",
        [
          _c("v-progress-linear", {
            attrs: {
              indeterminate: "",
              color: "teal",
              rounded: "",
              height: "8"
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9bd70f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9bd70f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Language.vue
// module id = null
// module chunks = 